import { render } from "./Chrome.vue?vue&type=template&id=41feb5bc"
import script from "./Chrome.vue?vue&type=script&lang=js"
export * from "./Chrome.vue?vue&type=script&lang=js"

import "./Chrome.vue?vue&type=style&index=0&id=41feb5bc&lang=css"

import exportComponent from "/home/mathias/PhpstormProjects/clone/vue3-color/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__